// frontend/src/components/common/Icon.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as faBrands from '@fortawesome/free-brands-svg-icons';
import * as faSolid from '@fortawesome/free-solid-svg-icons';

const iconMap = {
  // Redes sociales (brands)
  instagram: faBrands.faInstagram,
  twitter: faBrands.faTwitter,
  github: faBrands.faGithub,
  linkedin: faBrands.faLinkedin,
  youtube: faBrands.faYoutube,
  facebook: faBrands.faFacebook,
  whatsapp: faBrands.faWhatsapp,
  
  // Acciones (solid)
  save: faSolid.faSave,
  eye: faSolid.faEye,
  trash: faSolid.faTrashAlt,
  plus: faSolid.faPlus,
  chevronUp: faSolid.faChevronUp,
  chevronDown: faSolid.faChevronDown,
  droplet: faSolid.faDroplet,
  link: faSolid.faLink,
  image: faSolid.faImage,
  alert: faSolid.faExclamationCircle,
  edit: faSolid.faEdit,
  sun: faSolid.faSun,
  moon: faSolid.faMoon,
  fire: faSolid.faFire,
  leaf: faSolid.faLeaf,
  medicine: faSolid.faStethoscope,
  users: faSolid.faUsers

};

const Icon = ({ name, size = 20, className = '', color = 'currentColor' ,onClick}) => {
  const icon = iconMap[name];
  
  if (!icon) {
    console.warn(`Icono "${name}" no encontrado`);
    return null;
  }
  
  return (
    <FontAwesomeIcon 
      icon={icon} 
      className={className}
      onClick={onClick}
      style={{ fontSize: size, color }}
    />
  );
};

export default Icon;